module.exports = __webpack_public_path__ + "static/weather-app-0c12334ebdfc47a4ceed72aaa73a39cd.gif";